import {
  GETCUSTOMERBANKDETAILS_SUCCESS,
  GETCUSTOMERBANKDETAILS_FAILED,
  RESET_GETCUSTOMERBANKDETAILS,
  LOADING_GETCUSTOMERBANKDETAILS,
  NETWORK_ERROR_GETCUSTOMERBANKDETAILS,
} from "../types/index";


const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCUSTOMERBANKDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCUSTOMERBANKDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCUSTOMERBANKDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCUSTOMERBANKDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
